import React, { useState, useEffect, useContext } from "react";
import { Text, TextInput, View, FlatList, StyleSheet, TouchableOpacity, Modal } from "react-native";

import { PaymentMethodsContext } from "../context/PaymentMethodsContext";

import WooService from "../services/WooService";
import Config from "../config/Config";

const CASH_ID = 'dinheiro';

const config = new Config();

const BalanceEntriesScreen = ({ route, navigation }) => {
  const { paymentMethods } = useContext(PaymentMethodsContext);
  const [balanceHeader, setBalanceHeader] = useState();
  const [modalVisible, setModalVisible] = useState(false);
  const [entryValue, setEntryValue] = useState();
  const [entryNotes, setEntryNotes] = useState();
  const [entries, setEntries] = useState([]);

  const { action, closeCash, callback } = route.params;

  const wooService = new WooService();

  useEffect(() => {
    if (action === "cash-in") {
      setBalanceHeader("Suprimento");
    } else if (action === "cash-out") {
      setBalanceHeader("Sangria");
    } else if (action === "close") {
      setBalanceHeader("Fechamento do Caixa");
      let balanceEntries = [];
      for (const paymentMethod of paymentMethods) {
        balanceEntries.push({...paymentMethod, value: paymentMethod.id === CASH_ID ? closeCash : 0});
      }
      setEntries(balanceEntries);
    }
  }, []);

  saveOpenBalanceData = async () => {
    if (action === "cash-in" || action === "cash-out") {
      await wooService.saveOpenBalanceEntry(parseInt(entryValue*100), entryNotes, action, CASH_ID)
    } else if (action === "close") {
      const balanceEntries = entries.map(entry => {
        entry.value = parseInt(entry.value*100);
        return entry;
      });
      await wooService.closeBalance(parseInt(closeCash*100), balanceEntries);
      callback();
    }
    setModalVisible(false);

    navigation.goBack();    
    if (action === "close") {
      navigation.goBack();
    }
  }

  const updateEntries = (id, value) => {
    let balanceEntries = entries;
    for (var balanceEntry of balanceEntries) {
      if (balanceEntry.id === id) {
        balanceEntry.value = value;
      }
    }
    setEntries(balanceEntries);
  }

  goBack = () => {
    setModalVisible(false);
    navigation.goBack();
  }

  return (
    <View>
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible}>
        <View style={styles.modalView}>
            <Text style={styles.modalText}>Confirma o registro de R$ {entryValue}?</Text>
            <View style={{marginTop: 30}}>
                <TouchableOpacity style={styles.buttons} onPress={() => saveOpenBalanceData()}>
                    <Text style={styles.buttonText}>Confirmar</Text>
                </TouchableOpacity>
                <TouchableOpacity style={styles.buttons} onPress={() => setModalVisible(false)}>
                    <Text style={styles.buttonText}>Voltar</Text>
                </TouchableOpacity>
            </View>
        </View>     
      </Modal>
      <View style={styles.layout}>
        <Text style={styles.balanceHeader}>{balanceHeader}</Text>
        <View style={styles.amountsColumns}>
          {action === "close" &&
            <FlatList
            LisHeaderComponent={<Text></Text>}
            ListFooterComponent={<Text></Text>}
            contentContainerStyle={styles.listStyle}
            numColumns={1}
            data={entries}
            keyExtractor={entry => entry.id}
            renderItem={({ item }) => {
              if (item.id !== CASH_ID) {
                return (
                  <View style={{flexDirection: 'row'}}>
                    <Text style={[styles.listItems, {width: 300}]}>{item.name}</Text>
                    <TextInput
                      style={styles.valueInput}
                      keyboardType="numeric"
                      placeholder={item.value}
                      onChangeText={(text) => {
                        updateEntries(item.id, text);
                      }}
                    />
                  </View>
                );
              }
            }}
            />
          }
          {(action === "cash-out" || action === "cash-in") &&
            <View style={{margin: 20}}>
              <View style={{flexDirection: 'row'}}>
                <Text style={[styles.listItems, {width: 150}]}>Valor (R$)</Text>
                <TextInput
                  style={[styles.valueInput, {width: 100}]}
                  keyboardType="numeric"
                  placeholder={0}
                  value={entryValue}
                  onChangeText={(value) => {
                    value = value.replace(',', '.');
                    setEntryValue(value);
                  }}/>
              </View>
              <View style={{flexDirection: 'row', justifyContent: 'flex-start'}}>
                <Text style={[styles.listItems, {width: 150}]}>Observações</Text>
                <TextInput
                  style={[styles.textInput, {width: 300}]}
                  value={entryNotes}
                  onChangeText={(text) => {
                    setEntryNotes(text);
                  }}/>
              </View>
            </View>
          }
          <View style={{flexDirection: 'row'}}>
            <TouchableOpacity style={[styles.buttons, {marginHorizontal: 20}]} onPress={() => goBack()}>
              <Text style={styles.buttonText}>Voltar</Text>
            </TouchableOpacity>
            <TouchableOpacity style={[styles.buttons, {marginHorizontal: 20}]} onPress={() => setModalVisible(true)}>
              <Text style={styles.buttonText}>Registrar</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  layout: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1
  },
  balanceHeader: {
    color: 'rgb(150, 94, 17)', 
    fontSize: 24,
    fontWeight: 'bold',
    marginTop: 20
  },
  amountsColumns: {
    alignItems: 'center',
    margin: 20
  },
  listStyle: {
    margin: 15
  },
  listItems: {
    fontSize: 18,
    fontWeight: 'bold',
    marginVertical: 5
  },
  valueInput: {
    textAlign: 'center',
    backgroundColor: '#ccc',
    fontSize: 18
  },
  textInput: {
    padding: 10,
    backgroundColor: '#ccc',
    fontSize: 18
  },
  buttons: {
    backgroundColor: '#965E11',
    width: 160,
    marginVertical: 10,
    padding: 10,
    borderRadius: 10,
    alignSelf: 'center'
  },
  buttonText: {
      fontSize: 18,
      fontWeight: 'bold',
      alignSelf: 'center',
      color: 'white'
  },
  modalView: {
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    marginTop: 100,
    backgroundColor: "white",
    borderRadius: 20,
    paddingVertical: 50,
    paddingHorizontal: 70,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5
  },
  modalText: {
    fontSize: 16,
    fontWeight: "bold"
  }
});

export default BalanceEntriesScreen;